import { render, staticRenderFns } from "./AddCompanyOrderMenu.vue?vue&type=template&id=cd6bc512&scoped=true&"
import script from "./AddCompanyOrderMenu.vue?vue&type=script&lang=js&"
export * from "./AddCompanyOrderMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyOrderMenu.vue?vue&type=style&index=0&id=cd6bc512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6bc512",
  null
  
)

export default component.exports